import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { Link, useNavigate } from "react-router-dom";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import CartCard from "./CartCard";
import { CartCheckout } from "./CartCheckout";
import { useCart } from "../../context/cart-context";

const BRAND = "#194049";

export default function CartItemSection() {
  const navigate = useNavigate();
  const { cart, clearCart } = useCart();

  const handleClearCart = () => {
    clearCart();
    navigate("/shop");
  };

  return (
    <Box sx={{ px: { xs: 2, sm: 4, md: 6, lg: 10 }, py: { xs: 4, md: 8 } }}>
      <Grid container spacing={{ xs: 4, md: 6 }} alignItems="flex-start">

        {/* ── Left: items list ── */}
        <Grid item xs={12} md={8}>

          {/* Column headers (desktop) */}
          {cart.length > 0 && (
            <>
              <Box
                sx={{
                  display: { xs: "none", sm: "flex" },
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 0.5,
                  pb: 1.5,
                  borderBottom: "2px solid #111827",
                }}
              >
                <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.08em", flex: 1 }}>
                  Product
                </Typography>
                <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.08em", mr: { sm: 2, md: 4 } }}>
                  Qty
                </Typography>
                <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.08em", width: { sm: 76, md: 88 }, textAlign: "right", mr: 5 }}>
                  Total
                </Typography>
              </Box>
              <Divider sx={{ display: { sm: "none" }, mb: 1 }} />
            </>
          )}

          {/* Cart items */}
          {cart.length > 0 ? (
            cart.map((item, index) => <CartCard key={item.id || index} data={item} />)
          ) : (
            <Box sx={{ textAlign: "center", py: { xs: 8, md: 12 } }}>
              <ShoppingBagOutlinedIcon sx={{ fontSize: 52, color: "#e5e7eb", mb: 2 }} />
              <Typography sx={{ fontSize: 16, color: "#9ca3af", mb: 1 }}>Your cart is empty</Typography>
              <Typography sx={{ fontSize: 13, color: "#d1d5db", mb: 4 }}>
                Add some products to get started.
              </Typography>
              <Box
                component={Link}
                to="/shop"
                sx={{
                  display: "inline-block",
                  px: 4,
                  py: 1.5,
                  bgcolor: BRAND,
                  color: "#fff",
                  fontSize: 12,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  textDecoration: "none",
                  borderRadius: "6px",
                  "&:hover": { bgcolor: "#0f2a31" },
                }}
              >
                Continue Shopping
              </Box>
            </Box>
          )}

          {/* Footer actions */}
          {cart.length > 0 && (
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pt: 3, mt: 1 }}>
              <Box
                onClick={handleClearCart}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.75,
                  cursor: "pointer",
                  color: "#9ca3af",
                  fontSize: 13,
                  "&:hover": { color: "#ef4444" },
                  transition: "color 0.15s",
                  userSelect: "none",
                }}
              >
                <DeleteOutlineIcon sx={{ fontSize: 17 }} />
                Clear cart
              </Box>

              <Box
                component={Link}
                to="/shop"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.75,
                  textDecoration: "none",
                  color: BRAND,
                  fontSize: 13,
                  fontWeight: 500,
                  "&:hover": { opacity: 0.75 },
                }}
              >
                Continue Shopping
                <ArrowForwardIcon sx={{ fontSize: 16 }} />
              </Box>
            </Box>
          )}
        </Grid>

        {/* ── Right: order summary ── */}
        <Grid item xs={12} md={4}>
          <CartCheckout />
        </Grid>
      </Grid>
    </Box>
  );
}
